/* ==========================================================================
   Catalogue

   One entry per model (four supercars, four F1 cars), holding only what the page, the cart and the garage
   builder need to share. Prices are NOT here — they live in markets.js,
   keyed by this same handle. In the Shopify build each entry becomes a
   `product` object and this file goes away.

   variantId: fill in from Shopify once the products exist (SETUP_TODO.md).
   ========================================================================== */

window.STORE = window.STORE || {};

STORE.products = {
  'lamborghini-aventador-svj-green': {
    title: 'Lamborghini Aventador SVJ',
    colour: 'Green',
    variantId: '50385330667623',
    sku: 'PTL-AVSVJ-GRN',
    group: 'supercar alarm clock',
    category: 'supercars',
    subtitle: 'Supercar alarm clock · green',
    tagline: 'Loud green. Louder mornings.',
    url: '/products/lamborghini-aventador-svj-green',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-aventador-svj-green-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-aventador-svj-green-studio-asleep.jpg',
    theme: 't-green',
    swatch: '#a6d930',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-aventador-svj-green-studio-asleep.jpg',
    shift: 'Loud green. Louder mornings.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'porsche-911-gt3-rs-silver': {
    title: 'Porsche 911 GT3 RS',
    colour: 'Silver',
    variantId: '50385330700391',
    sku: 'PTL-GT3RS-SLV',
    group: 'supercar alarm clock',
    category: 'supercars',
    subtitle: 'Supercar alarm clock · silver',
    tagline: 'Big wing. Early start.',
    url: '/products/porsche-911-gt3-rs-silver',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-911-gt3-rs-silver-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-911-gt3-rs-silver-studio-asleep.jpg',
    theme: 't-silver',
    swatch: '#c9ced6',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-911-gt3-rs-silver-studio-asleep.jpg',
    shift: 'Big wing. Early start.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'nissan-skyline-gt-r-r34-blue': {
    title: 'Nissan Skyline GT-R R34',
    colour: 'Blue',
    variantId: '50385330733159',
    sku: 'PTL-R34GTR-BLU',
    group: 'supercar alarm clock',
    category: 'supercars',
    subtitle: 'Supercar alarm clock · blue',
    tagline: 'Poster car. Alarm clock.',
    url: '/products/nissan-skyline-gt-r-r34-blue',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-skyline-gt-r-r34-blue-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-skyline-gt-r-r34-blue-studio-asleep.jpg',
    theme: 't-blue',
    swatch: '#2f5bff',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-skyline-gt-r-r34-blue-studio-asleep.jpg',
    shift: 'Poster car. Alarm clock.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'mclaren-750s-orange': {
    title: 'McLaren 750S',
    colour: 'Orange',
    variantId: '50385330765927',
    sku: 'PTL-750S-ORG',
    group: 'supercar alarm clock',
    category: 'supercars',
    subtitle: 'Supercar alarm clock · orange',
    tagline: 'Orange body. Red-hot seven.',
    url: '/products/mclaren-750s-orange',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-mclaren-750s-orange-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-mclaren-750s-orange-studio-asleep.jpg',
    theme: 't-orange',
    swatch: '#ff7a1a',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-mclaren-750s-orange-studio-asleep.jpg',
    shift: 'Orange body. Red-hot seven.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'f1-rb22-navy': {
    title: 'RB22',
    colour: 'Navy',
    variantId: '50385330798695',
    sku: 'PTL-F1RB22-NVY',
    group: 'F1 alarm clock',
    category: 'f1',
    subtitle: 'F1 alarm clock · navy',
    tagline: 'Lights out at 06:59. Go at 07:00.',
    url: '/products/f1-rb22-navy',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-rb22-navy-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-rb22-navy-studio-asleep.jpg',
    theme: 't-navy',
    swatch: '#1f2d6b',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-rb22-navy-studio-asleep.jpg',
    shift: 'Lights out at 06:59. Go at 07:00.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'f1-w17-black': {
    title: 'W17',
    colour: 'Black & teal',
    variantId: '50385330831463',
    sku: 'PTL-F1W17-BLK',
    group: 'F1 alarm clock',
    category: 'f1',
    subtitle: 'F1 alarm clock · black & teal',
    tagline: 'Black, teal, first on the grid.',
    url: '/products/f1-w17-black',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-w17-black-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-w17-black-studio-asleep.jpg',
    theme: 't-teal',
    swatch: '#00a19b',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-w17-black-studio-asleep.jpg',
    shift: 'Black, teal, first on the grid.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'f1-sf-26-red': {
    title: 'SF-26',
    colour: 'Red & white',
    variantId: '50385330864231',
    sku: 'PTL-F1SF26-RED',
    group: 'F1 alarm clock',
    category: 'f1',
    subtitle: 'F1 alarm clock · red & white',
    tagline: 'Red car. Early start.',
    url: '/products/f1-sf-26-red',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-sf-26-red-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-sf-26-red-studio-asleep.jpg',
    theme: 't-red',
    swatch: '#d81e1e',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-sf-26-red-studio-asleep.jpg',
    shift: 'Red car. Early start.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
  'f1-mcl40-papaya': {
    title: 'MCL40',
    colour: 'Papaya',
    variantId: '50385330896999',
    sku: 'PTL-F1MCL40-PAP',
    group: 'F1 alarm clock',
    category: 'f1',
    subtitle: 'F1 alarm clock · papaya',
    tagline: 'Papaya on pole by seven.',
    url: '/products/f1-mcl40-papaya',
    image: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-mcl40-papaya-studio-asleep.jpg',
    thumb: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-mcl40-papaya-studio-asleep.jpg',
    theme: 't-papaya',
    swatch: '#ff8000',
    studio: 'https://cdn.shopify.com/s/files/1/0690/0629/5143/files/clock-f1-mcl40-papaya-studio-asleep.jpg',
    shift: 'Papaya on pole by seven.',
    preorder: false,
    addLabel: 'Add to Cart',
    available: true,
  },
};
